export default "__VITE_ASSET__4pst$oNE__"